import * as React from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";

const Footer = () => {
  const [value, setValue] = React.useState(0);

  return (
    <Box sx={{ width: "100%", position: "fixed", bottom: 0 }}>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        <BottomNavigationAction
          label="WhatsApp"
          icon={
            <img
              src="/assets/svg/whatsapp-svgrepo-com.svg"
              alt="WhatsApp Channel"
              width={24}
              height={24}
            />
          }
          component="a"
          href="https://whatsapp.com/channel/0029VbAl1CKLSmbhYk5uyT2v"
          target="_blank"
          rel="noopener noreferrer"
        />
        <BottomNavigationAction
          label="Instagram"
          icon={
            <img
              src="/assets/svg/instagram-1-svgrepo-com.svg"
              alt="Instagram"
              width={24}
              height={24}
            />
          }
          component="a"
          href="https://www.instagram.com/navegante.space"
          target="_blank"
          rel="noopener noreferrer"
        />
        <BottomNavigationAction
          label="TikTok"
          icon={
            <img
              src="/assets/svg/tiktok-svgrepo-com.svg"
              alt="TikTok"
              width={24}
              height={24}
            />
          }
          component="a"
          href="https://www.tiktok.com/@navegante.space"
          target="_blank"
          rel="noopener noreferrer"
        />
      </BottomNavigation>
    </Box>
  );
};

export default Footer;
